import {
	CLEAR_SELF_SETTINGS_ERRORS,
	SELF_SETTING_CREATE_LOADING,
	SELF_SETTING_CREATE_ERROR,
	ALL_SELF_SETTINGS_LOADING,
	ALL_SELF_SETTINGS_GET,
	ALL_SELF_SETTINGS_ERROR,
	SELF_SETTING_UPDATE_LOADING,
	SELF_SETTING_UPDATE_ERROR,
	SELF_SETTING_DELETE_LOADING
} from '../types';

const initialState = {
	self_setting_create_loading: false,
	all_self_settings_loading: false,
	all_self_settings: { count: 0, settings: [] },
	self_setting_update_loading: false,
	self_setting_delete_loading: false,
	self_settings_errors: {}
}

export default function selfSettingReducer(state = initialState, action){
	switch(action.type){
		case CLEAR_SELF_SETTINGS_ERRORS:
			return {
				...state,
				self_settings_errors: {}
			}
		case SELF_SETTING_CREATE_LOADING:
			return {
				...state,
				self_setting_create_loading: action.payload
			}
		case ALL_SELF_SETTINGS_LOADING:
			return {
				...state,
				all_self_settings_loading: action.payload
			}
		case ALL_SELF_SETTINGS_GET:
			return {
				...state,
				all_self_settings: {
					count: action.payload.count,
					settings: action.payload.settings
				}
			}
		case SELF_SETTING_UPDATE_LOADING:
			return {
				...state,
				self_setting_update_loading: action.payload
			}
		case SELF_SETTING_DELETE_LOADING:
			return {
				...state,
				self_setting_delete_loading: action.payload
			}
		case SELF_SETTING_CREATE_ERROR:
		case ALL_SELF_SETTINGS_ERROR:
		case SELF_SETTING_UPDATE_ERROR:
			return {
				...state,
				self_settings_errors: {
					...state.self_settings_errors, 
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
